<template>
    <card title="Horizontal Form">
        <h4 slot="header" class="card-title">
            WEB2.0會員查詢
        </h4>
        
        <div class="container">
            <div class="row d-flex">
                <div class="col-md-5">
                    <div class="search-area">
                        <el-input v-model="searchPhone" placeholder="請輸入電話號碼"></el-input>
                    </div>
                </div>
                <div class="col-md-3">
                    <el-button type="primary" @click="fetchMembers">Search</el-button>
                </div>
            </div>
        </div>

        <data-tables :data="membersData">
            <el-table-column prop="id" label="ID" width="150"></el-table-column>
            <el-table-column prop="name" label="Name"></el-table-column>
            <el-table-column label="Phone">
                <template slot-scope="scope">
                    <div v-if="editRowId !== scope.row.id">
                        {{ scope.row.phone }}
                    </div>
                    <el-input v-else v-model="editPhone" placeholder="請輸入新電話號碼"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="email" label="Email"></el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button :type="editRowId === scope.row.id ? 'danger' : 'warning'" @click="toggleEdit(scope.row)">
                        {{ editRowId === scope.row.id ? 'Save' : 'Reset Phone' }}
                    </el-button>
                </template>
            </el-table-column>
        </data-tables>

    </card>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            searchPhone: '', // 用戶要搜尋的電話號碼
            membersData: [],
            editRowId: null,
            editPhone: ''
        }
    },
    methods: {
        toggleEdit(member) {
            if (this.editRowId === member.id) {
                this.editMember(member, this.editPhone);
                this.editRowId = null;
                this.editPhone = '';
            } else {
                this.editRowId = member.id;
                this.editPhone = member.phone;
            }
        },
        async fetchMembers() {
            try {
                const encodedPhone = encodeURIComponent(this.searchPhone);
                const response = await axios.get(`${process.env.VUE_APP_APIHOST}/gaa/members?phone=${encodedPhone}`);
                this.membersData = response.data.data;
            } catch (error) {
                console.error("Error fetching members:", error);
            }
        },

        async editMember(member, newPhone) {
            try {
                await axios.put(`${process.env.VUE_APP_APIHOST}/gaa/members/phone`, {
                    id: member.id,
                    newPhone: newPhone,
                    originalPhone: member.phone,
                });
                this.fetchMembers();
            } catch (error) {
                const errorMessage = error.data && error.data.message 
                        ? error.data.message 
                        : 'Error updating member phone';
                this.$message.error(errorMessage);
                console.error('Error updating member phone:', error);
            }
        } 
    }
}
</script>